import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, ConfigProvider, Row } from "antd";
import ar_EG from "antd/lib/locale/ar_EG";
import {
  getEndowment,
  getEndowmentTypes,
} from "../../../../apis/actions/sponsor.actions";
import { AppDispatch, RootState } from "../../../../apis/store";
import { scroll } from "../../../../components/utils/utils";
import Selects from "../../../../biblio/Selects/Selects";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import EndowmentList from "./EndowmentList";

const EndowmentOverview = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    dispatch(getEndowment());
    dispatch(getEndowmentTypes());
  }, [dispatch]);
  const { endowment, endowmentTypes, loading } = useSelector(
    (state: RootState) => state?.sponsor
  );
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredendowndata, setFilteredEndowndata] = useState<any[]>([]);

  useEffect(() => {
    let list = [...endowment];
    if (selectedFilter)
      list = list?.filter(
        (request: any) => request?.endowment_type_id === selectedFilter
      );

    setCurrentPage(1);
    setFilteredEndowndata(list);
  }, [endowment, selectedFilter]);
  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 8;

  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedFilter(value.label);
    } else {
      setSelectedFilter(null);
    }
    setCurrentPage(1);
  };

  return (
    <>
      <ConfigProvider locale={ar_EG} direction="rtl">
        <Row gutter={8} dir="rtl" style={{ marginBottom: "0.5rem" }}>
          <Col xxl={20} xl={20} lg={20} md={20} sm={24} xs={24}>
            <span className="takaful--service-section-title">الأوقاف </span>
          </Col>
          <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
            <Selects
              options={endowmentTypes}
              selectPlaceholder="نوع الوقف"
              onChange={handleSelectChange}
              allowClear={true}
              className="takaful--service-select takaful--request-select"
              popupClassName="takaful--service-select-dropdown"
            />
          </Col>
        </Row>
      </ConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : endowment?.length === 0 ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد أوقاف
        </p>
      ) : filteredendowndata?.length === 0 ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد أوقاف تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <EndowmentList
              endowments={filteredendowndata?.slice(
                (currentPage - 1) * itemPerPage,
                (currentPage - 1) * itemPerPage + itemPerPage
              )}
            />
          </Row>
          <div className="takaful--pagination-container">
            {filteredendowndata && filteredendowndata?.length > itemPerPage && (
              <PaginationComponent
                active={currentPage}
                total={filteredendowndata?.length}
                itemPerPage={itemPerPage}
                scroll={() => scroll(currentRef)}
                setActive={(nb) => updateActive(nb)}
              />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default EndowmentOverview;


